import React, {Component} from 'react';
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import Alert from "react-s-alert";
import {validateComponent} from "../../../common/validation";
import {deepCopyObject} from "../../../helper/helper";

class AliasEditModal extends Component {

	constructor(props) {
		super(props);

		this.state = {
			error: {},
			aliasForUpdate : null,
			workscopeCode : "",
		};

		this.onChangeAlias = this.onChangeAlias.bind(this);
		this.validateComponent = this.validateComponent.bind(this);
		this.onChangeAlias = this.onChangeAlias.bind(this);
		this.updateAlias = this.updateAlias.bind(this);
		this.splitAlias = this.splitAlias.bind(this);
	}

	componentDidMount() {
		if(this.props.aliasForUpdate && this.props.aliasForUpdate.workScopecode){
			let workScopecode = this.props.aliasForUpdate.workScopecode.replace('urn:mail:','');
			this.setState({workScopecode});
		}else{
			return;
		}
	}

	validateComponent() {
		let result = validateComponent(this);
		this.setState({
			error: result.error
		});
		return result;
	}

	onChangeAlias(e){
		let regex = new RegExp(/[ şŞıİçÇöÖüÜĞğ]/g);

		if(e.target.value.match(regex) === null) {

			this.setState({
				workScopecode : e.target.value
			});

		} else {
			Alert.warning('Etikette Türkçe Karakter Kullanmayınız!', {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 5000
			});
		}
	}

	splitAlias(workScopecode, type) {
		if(!workScopecode || !type)
			return "";
		let res = workScopecode.split("@");
		if (res[0][res[0].length - 2] === type[0] && res[0][res[0].length - 1] === type[1]) {
			return workScopecode;
		} else {
			if(workScopecode)
				workScopecode = res[0] + type + "@" + res[1];
			return workScopecode;
		}
	}

	updateAlias(){
		let self = this;
		let validity = this.validateComponent();

		if (validity.valid) {
			this.props.disableButtons();
			let aliasForUpdate = deepCopyObject(self.props.aliasForUpdate);
			aliasForUpdate.workScopecode = 'urn:mail:' + self.splitAlias(self.state.workScopecode, self.props.aliasForUpdate.userRolecode.toString().toLowerCase());
			aliasForUpdate.processState = 100;
			aliasForUpdate.processResult = 0;
			self.setState({aliasForUpdate}, () => this.props.updateAlias(aliasForUpdate));

		} else {
			Alert.error( "Etiket e-posta formatında olmalıdır!", {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 5000
			});
		}
	}

	render() {
		return (
			<div>

				<Modal isOpen={this.props.modal}>
					<ModalHeader toggle={() => this.props.toggle()}>Etiket Düzenle</ModalHeader>
					<ModalBody>
						<div>
							<div className="col-sm-12 row">
								<div className="col-sm-5">
									<label className="col-form-label">Etiket Düzenle</label>
								</div>

								<div className="col-sm-7" style={{maxWidth: "none"}}>
									<div >
										<input className="form-control"
											   type="text"
											   name="alias"
											   id="tAlias"
											   data-vlength="1,350"
											   data-vdata="email"
											   placeholder='birisi_gb@eposta.com'
											   ref="tAlias"
											   value={this.state.workScopecode ? this.state.workScopecode : ""}
											   onChange={(e) => this.onChangeAlias(e)}
										/>
									</div>
								</div>
							</div>
						</div>
					</ModalBody>
					<ModalFooter>
						<nav className="col-sm-12 row">
							<div className="col-sm-3">
								<button position="leftSide"
										label="İptal"
										className="TekBtn vazgec"
										style={{background: 'rgb(158, 158, 158)', padding:'9px 37px 9px 14px'}}
										disabled={this.props.aliasUpdateModalButtonsDisabled}
										onClick={() => this.props.toggle()}> İptal </button>
							</div>
							<div className="col-sm-6"></div>
							<div className="col-sm-3">
								<button position="rightSide"
										label="Kaydet"
										className="TekBtn kaydet"
										disabled={this.props.aliasUpdateModalButtonsDisabled}
										style={{background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)', padding:'9px 37px 9px 14px'}}
										onClick={this.updateAlias}> Kaydet</button>
							</div>
						</nav>
					</ModalFooter>
				</Modal>
			</div>
		)
	}
}

export default AliasEditModal;